import { useTheme } from "@emotion/react";
import { HomeOutlined } from "@mui/icons-material";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import EggOutlinedIcon from "@mui/icons-material/EggOutlined";
import { DarkModeOutlined, LightModeOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setLogout, setMode } from "reduxStore/state";
import { checkRoles } from "utils/permissions";

export const useSideBar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);

  const fullName = user?.firstName + " " + user?.lastName;

  const mode = useSelector((state) => state.mode);

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const { isSystemAdmin } = checkRoles(user);

  const { palette } = useTheme();
  const primary = palette.primary.main;
  const backgroundColor = palette.background.alt;
  const dark = palette.neutral.dark;
  const secondaryDark = palette.secondary.dark;

  const handleLogout = () => {
    dispatch(setLogout());
    navigate("/");
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const handleClose = () => {
    setLogoutDialogOpen(false);
  };

  const handleModeToggle = () => {
    dispatch(setMode());
  };

  const navItems = [
    { text: "Product Library", path: "home", icon: <HomeOutlined /> },
    { text: "Ingredients", path: "ingredients", icon: <EggOutlinedIcon /> },
    // { text: "ALT Admin", icon: null },
    isSystemAdmin && {
      text: "System Admin",
      path: "admin",
      icon: <CorporateFareIcon />,
    },
    {
      text: mode === "light" ? "Dark Mode" : "Light Mode",
      path: "mode",
      icon: mode === "light" ? <DarkModeOutlined /> : <LightModeOutlined />,
    },
  ].filter(Boolean);

  useEffect(() => {
    const lastPath = pathname.split("/").pop();
    setActive(lastPath);
  }, [pathname]);

  return {
    active,
    handleLogout,
    handleLogoutClick,
    fullName,
    logoutDialogOpen,
    navItems,
    primary,
    backgroundColor,
    dark,
    secondaryDark,
    user,
    navigate,
    setActive,
    handleClose,
    handleModeToggle,
  };
};
